module.exports = __webpack_public_path__ + "img/g.f667c522.jpg";